import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H5, Small } from "@/components/standard/BFText"
import Calculator from "phosphor-react-native/src/icons/Calculator"

export function LoanDetailsDisclaimer() {
  return (
    <Horizontal
      className={
        "bg-teal rounded p-3 border-midnight-blue flex-1 gap-2 justify-center items-center"
      }
    >
      <Calculator size={24} color="#121F3A" />
      <Vertical className={"flex-1"}>
        <H5 color={"default"}>Here&apos;s your initial estimate</H5>
        <Small>Submit below to receive final term options</Small>
      </Vertical>
    </Horizontal>
  )
}
